import { render, staticRenderFns } from "./masuk.vue?vue&type=template&id=60b1a6ce&"
import script from "./masuk.vue?vue&type=script&lang=js&"
export * from "./masuk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports